// Editable fields from the Operational Lookup API handoff.
const fields = [
    {
        "name": "utilityId",
        "label": "Utility",
        "type": "lookup-select",
        "required": true,
        "source": "operational-utilities",
        "labelField": "utilityName"
    },
    {
        "name": "billingTypeId",
        "label": "Billing type",
        "type": "lookup-select",
        "idType": "guid",
        "required": true,
        "source": "billing-types",
        "labelField": "billingTypeName"
    },
    {
        "name": "utilityName",
        "type": "hidden",
        "displayOnly": true
    },
    {
        "name": "billingTypeName",
        "type": "hidden",
        "displayOnly": true
    }
];
export default fields;
